import react from 'react';
import { isMobile, isBrowser, isAndroid } from 'react-device-detect';
import { ISections, ISectionsInfo } from 'screens/salary_specification/detail/DetailPay';

import SectionTableDetail from './SectionTableDetail';
import SectionTableInfo from './SectionTableInfo';
import { IEmpInPayTransfer } from 'types/salary';

import './salary.scss';
interface IProps {
  DetailData: IEmpInPayTransfer;
  ProvideData: ISections[];
  ProvideDataInfo: ISectionsInfo[];
  DeductionData: ISections[];
  DeductionDataInfo: ISectionsInfo[];
  SectionRef1: react.RefObject<HTMLDivElement>;
  SectionRef2: react.RefObject<HTMLDivElement>;
  SectionRef3: react.RefObject<HTMLDivElement>;
  ScrollSection: (index: number) => void;
  PAYTYPE: string;
}

const DetailPayMid = ({
  DetailData,
  ProvideData,
  ProvideDataInfo,
  DeductionData,
  DeductionDataInfo,
  SectionRef1,
  SectionRef2,
  SectionRef3,
  ScrollSection,
  PAYTYPE,
}: IProps) => {
  const SectionTitle = ({ title, color }: { title: string; color: string }) => {
    return (
      <div className="SectionTitle">
        <span style={{ backgroundColor: color }}>{title}</span>
      </div>
    );
  };

  return (
    <div className="DP_Mid">
      <div className="DP_MidMenu">
        <button onClick={() => ScrollSection(0)}>
          {isMobile && (
            <img
              src={require('assets/images/detailIcon1.png')}
              alt="detailPayMid_Icon"
              width={isAndroid ? '34' : '51'}
              height={isAndroid ? '35' : '52'}
              //   objectFit={"scale-down"}
            />
          )}
          <span>내 정보</span>
        </button>
        <i className="DP_MidBar" />
        <button onClick={() => ScrollSection(1)}>
          {isMobile && (
            <img
              src={require('assets/images/detailIcon2.png')}
              alt="detailPayMid_Icon"
              width={isAndroid ? '32' : '49'}
              height={isAndroid ? '32' : '49'}
              //   objectFit={"scale-down"}
            />
          )}
          <span>지급</span>
        </button>
        <i className="DP_MidBar" />
        <button onClick={() => ScrollSection(2)}>
          {isMobile && (
            <img
              src={require('assets/images/detailIcon3.png')}
              alt="detailPayMid_Icon"
              width={isAndroid ? '28' : '42'}
              height={isAndroid ? '35' : '53'}
              //   objectFit={"scale-down"}
            />
          )}
          <span>공제</span>
        </button>
      </div>
      <div ref={SectionRef1} className="DP_MidSection">
        <SectionTitle title={'내 정보'} color={'#1472FF'} />
        <div className="DP_MidEmpInfo">
          <table>
            <thead>
              <tr>
                <th>이름</th>
                <th>생년월일</th>
                <th>급여정산일</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{DetailData.NAME}</td>
                <td>{DetailData.SS_NUMBER}</td>
                <td>{DetailData.PayDay}</td>
              </tr>
            </tbody>
          </table>
          <table>
            <thead>
              <tr>
                <th>급여유형</th>
                <th>세금유형</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{PAYTYPE == '0' ? '시급' : PAYTYPE == '1' ? '일급' : PAYTYPE == '2' ? '월급' : '직접입력'}</td>
                <td>{DetailData.STANDARD_TAX == '0' ? '4대보험' : DetailData.STANDARD_TAX == '1' ? '3.3%' : '없음'}</td>
              </tr>
            </tbody>
          </table>
          <table>
            <thead>
              <tr>
                <th>부서</th>
                <th>직급</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{DetailData.department}</td>
                <td>{DetailData.rank}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div ref={SectionRef2} className="DP_MidSection">
        <SectionTitle title={'지급'} color={'#1E62C8'} />
        <div className="DP_SectionTableArea">
          <SectionTableDetail Title={'지급내역'} TableData={ProvideData} PAYTYPE={PAYTYPE} />
          {isBrowser && <i className="DP_MidBar" style={{ margin: '0 3%' }} />}
          <SectionTableInfo Title={'지급 계산 내역'} TableData={ProvideDataInfo} PAYTYPE={PAYTYPE} />
        </div>
      </div>
      <div ref={SectionRef3} className="DP_MidSection">
        <SectionTitle title={'공제'} color={'#6796DC'} />
        <div className="DP_SectionTableArea">
          <SectionTableDetail Title={'공제내역'} TableData={DeductionData} />
          {isBrowser && <i className="DP_MidBar" style={{ margin: '0 3%' }} />}
          <SectionTableInfo Title={'공제 계산 내역'} TableData={DeductionDataInfo} DetailData={DetailData} />
        </div>
      </div>
    </div>
  );
};

export default DetailPayMid;
